import React from 'react'
import PageHeader from '../components/PageHeader'
import PageContent from '../components/PageContent'
import Blog from '../components/Blog'

function CommonRoom() {
  return (
    <div>
      <PageHeader title="Common Room" />
      <PageContent elem={<Blog image='' content='<p>Separate common rooms for boys and girls provide a space for relaxation and interaction among students.</p>' />}/>
    </div>
  )
}

export default CommonRoom
